import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface HealthState {
  category: string;
  data: any;
  urlsData: any[];
  enabledSections: any[];
  loading: boolean;
  showAddUrlModal: boolean;
  toggleLoader: boolean;
  saveLoading: boolean;
}

const initialState: HealthState = {
  category: "splash",
  data: [],
  urlsData: [],
  enabledSections: [],
  loading: true,
  showAddUrlModal: false,
  toggleLoader: false,
  saveLoading: false,
};

export const appCustomizationSlice = createSlice({
  name: "appCustomization",
  initialState: initialState,
  reducers: {
    setCategory: (state, action: PayloadAction<string>) => {
      state.category = action.payload;
    },
    setData: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
    setUrlsData: (state, action: PayloadAction<any[]>) => {
      state.urlsData = action.payload;
    },
    setEnabledSections: (state, action: PayloadAction<any>) => {
      state.enabledSections = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setShowModal: (state, action: PayloadAction<boolean>) => {
      state.showAddUrlModal = action.payload;
    },
    setToggleLoader: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    setSaveLoader: (state, action: PayloadAction<boolean>) => {
      state.saveLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setCategory,
  setData,
  setUrlsData,
  setEnabledSections,
  setLoading,
  setShowModal,
  setToggleLoader,
  setSaveLoader,
  reset,
} = appCustomizationSlice.actions;

export default appCustomizationSlice.reducer;
